const useAppAbility = () => {
  return {};
};

export default useAppAbility;
